import { WS_CLOSE_CODE } from 'cpool-constants';

import type { WsCloseAction } from './wsCloseAction';

export type ChatSocketCloseDeps = {
    onForbidden?: () => void;
    renew: () => Promise<boolean>;
    scheduleReconnect: () => void;
};

export function handleChatSocketCloseEvent(
    code: number,
    { onForbidden, renew, scheduleReconnect }: ChatSocketCloseDeps,
): WsCloseAction {
    if (code === WS_CLOSE_CODE.FORBIDDEN) {
        onForbidden?.();
        return 'forbidden';
    }

    if (code === WS_CLOSE_CODE.UNAUTHENTICATED || code === WS_CLOSE_CODE.TOKEN_EXPIRED) {
        renew()
            .then((renewed) => {
                if (renewed) scheduleReconnect();
            })
            .catch(() => scheduleReconnect());
        return 'reauth';
    }

    scheduleReconnect();
    return 'reconnect';
}
